import { AxiosError } from 'axios'

import { httpClient } from 'shared/lib'
import isAxiosError from 'shared/utils/helpers/isAxiosError'
import consoleMessage from 'shared/utils/helpers/consoleMessage'

import { ReflinkDataType } from '../types'

export function getReflinkDataService(reflinkUuid: string, verificationHeader: string) {
   let errMessage = ''
   return httpClient
      .get<ReflinkDataType>(`/client-carts/reflinks/${reflinkUuid}`, {
         headers: {
            'X-Reflink-Verification-Code': verificationHeader,
         },
      })
      .then((res) => ({ data: res.data, status: res.status }))
      .catch((error: Error | AxiosError<ErrorType>) => {
         if (isAxiosError<ErrorType>(error)) {
            errMessage = error.response?.data?.errors[0].defaultMessage || ''
         } else {
            errMessage = error.message
         }
         consoleMessage('CLIENT_CART_REFLINK getReflinkData service', errMessage, 'error')
         throw error
      })
}
